module.exports = __webpack_public_path__ + "img/blackcat.61cf6525.png";